import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  const [activePortfolioFilter, setActivePortfolioFilter] = useState('all');
  const [isVisible, setIsVisible] = useState({
    services: false,
    portfolio: false,
    process: false,
    testimonials: false,
    tech: false
  });
  
  // Animation on scroll
  useEffect(() => {
    const observerOptions = {
      threshold: 0.15,
      rootMargin: '0px 0px -100px 0px'
    };
    
    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          setIsVisible(prev => ({
            ...prev,
            [sectionId]: true
          }));
        }
      });
    };
    
    const observer = new IntersectionObserver(observerCallback, observerOptions);
    
    const sections = ['services', 'portfolio', 'process', 'testimonials', 'tech'];
    sections.forEach(section => {
      const element = document.getElementById(section);
      if (element) observer.observe(element);
    });
    
    return () => {
      sections.forEach(section => {
        const element = document.getElementById(section);
        if (element) observer.unobserve(element);
      });
    };
  }, []);
  
  const portfolioItems = [
    {
      id: 1,
      title: "E-commerce Platform for Irish Retailer",
      category: "web",
      image: "/images/portfolio/ecommerce.jpg",
      client: "Dublin Retail Co."
    },
    {
      id: 2,
      title: "Fitness Tracking App",
      category: "mobile",
      image: "/images/portfolio/fitness-app.jpg",
      client: "HealthTrack Ireland"
    },
    {
      id: 3,
      title: "Corporate Rebrand & Website",
      category: "design",
      image: "/images/portfolio/corporate-site.jpg",
      client: "GreenEnergy Ltd."
    },
    {
      id: 4,
      title: "Property Management Platform",
      category: "web",
      image: "/images/portfolio/property-platform.jpg",
      client: "HomeBase Properties"
    },
    {
      id: 5,
      title: "Restaurant Ordering System",
      category: "software",
      image: "/images/portfolio/restaurant-system.jpg",
      client: "Taste of Dublin"
    },
    {
      id: 6,
      title: "Travel Companion App",
      category: "mobile",
      image: "/images/portfolio/travel-app.jpg",
      client: "IrishJourneys"
    }
  ];
  
  const filteredPortfolio = activePortfolioFilter === 'all' 
    ? portfolioItems 
    : portfolioItems.filter(item => item.category === activePortfolioFilter);
    
  const testimonials = [
    {
      id: 1,
      content: "OpiTech transformed our online presence with a stunning website and e-commerce platform. Sales have increased by 150% since launch!",
      author: "Sarah O'Sullivan",
      position: "CEO, Dublin Retail Co.",
      avatar: "/images/testimonials/testimonial1.jpg"
    },
    {
      id: 2,
      content: "The team at OpiTech delivered our mobile app ahead of schedule and exceeded all our expectations. Their technical expertise is second to none.",
      author: "James Murphy",
      position: "Founder, HealthTrack Ireland",
      avatar: "/images/testimonials/testimonial2.jpg"
    },
    {
      id: 3,
      content: "Working with OpiTech was a game-changer for our business. Their custom software solution streamlined our operations and saved us thousands.",
      author: "Michael Kennedy",
      position: "Operations Director, HomeBase Properties",
      avatar: "/images/testimonials/testimonial3.jpg"
    }
  ];

  const services = [
    {
      icon: "fas fa-laptop-code",
      title: "Web Development",
      description: "Custom websites and web applications that are fast, responsive, and optimized for all devices."
    },
    {
      icon: "fas fa-mobile-alt",
      title: "Mobile App Development",
      description: "Native and cross-platform mobile applications for iOS and Android that delight users."
    },
    {
      icon: "fas fa-palette",
      title: "UI/UX Design",
      description: "User-centered design that creates beautiful, intuitive interfaces and exceptional user experiences."
    },
    {
      icon: "fas fa-shopping-cart",
      title: "E-Commerce Solutions",
      description: "Powerful online stores with seamless checkout processes, payment gateway integration and inventory management."
    },
    {
      icon: "fas fa-cogs",
      title: "Custom Software",
      description: "Tailor-made software solutions that automate processes, increase efficiency and solve unique business challenges."
    },
    {
      icon: "fas fa-chalkboard-teacher",
      title: "IT Consultancy",
      description: "Strategic technology consulting to help you make informed decisions about your digital infrastructure."
    }
  ];
  
  return (
    <>
      {/* Hero Section */}
      <section className="hero">
        <div className="container hero-container">
          <div className="hero-content">
            <h1 className="hero-title animate-fadeUp">
              We Create <span>Digital Experiences</span> That Elevate Brands
            </h1>
            <p className="hero-description animate-fadeUp delay-1">
            OpiTech is a premier digital studio based in Dublin, crafting beautiful, 
              functional, and impactful websites and applications that help businesses thrive in the digital age.
            </p>
            <div className="hero-buttons animate-fadeUp delay-2">
              {/* <Link to="/portfolio" className="btn btn-icon">
                <span>View Our Work</span>
                <i className="fas fa-arrow-right ml-1"></i>
              </Link> */}
              <Link to="/contact" className="btn btn-icon">
                <span>Let's Talk</span>
                <i className="fas fa-comment ml-1"></i>
              </Link>
            </div>
          </div>
          <div className="hero-image animate-fadeUp delay-2">
            <img src="/images/hero-image.png" alt="Digital design concept" />
          </div>
        </div>
        
        <div className="hero-graphics">
          <div className="hero-circle hero-circle-1"></div>
          <div className="hero-circle hero-circle-2"></div>
          <div className="hero-circle hero-circle-3"></div>
        </div>
      </section>

      {/* Brands Section */}
      {/* <section className="section-sm">
        <div className="container">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            flexWrap: 'wrap', 
            gap: '4rem',
            opacity: '0.6'
          }}>
            <img src="/images/clients/client1.svg" alt="Client 1" style={{ height: '30px' }} />
            <img src="/images/clients/client2.svg" alt="Client 2" style={{ height: '30px' }} />
            <img src="/images/clients/client3.svg" alt="Client 3" style={{ height: '30px' }} />
            <img src="/images/clients/client4.svg" alt="Client 4" style={{ height: '30px' }} />
            <img src="/images/clients/client5.svg" alt="Client 5" style={{ height: '30px' }} />
          </div>
        </div>
      </section> */}

      {/* Services Section */}
      <section id="services" className={`section ${isVisible.services ? 'animate-fadeUp' : ''}`}>
        <div className="container">
          <div className="text-center">
            <p className="section-subtitle">What We Do</p>
            <h2 className="section-title">Our Services</h2>
            <div className="divider"></div>
            <p className="section-description">
              We offer end-to-end digital solutions for businesses of all sizes, from startups to established enterprises. 
              Our team of experts will help you at every stage of your digital journey.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div 
                key={index} 
                className="service-card"
                style={{ animationDelay: `${0.1 * index}s` }}
              >
                <div className="service-icon">
                  <i className={service.icon}></i>
                </div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">
                  {service.description}
                </p>
                <Link to={`/services/${service.title.toLowerCase().replace(/\s+/g, '-')}`} className="btn btn-outline">
                  Learn More
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Portfolio Section */}
      {/* <section id="portfolio" className={`section ${isVisible.portfolio ? 'animate-fadeUp' : ''}`} style={{ backgroundColor: 'rgba(17, 24, 39, 0.4)' }}>
        <div className="container">
          <div className="text-center">
            <p className="section-subtitle">Our Work</p>
            <h2 className="section-title">Featured Projects</h2>
            <div className="divider"></div>
            <p className="section-description">
              We've helped businesses across Ireland and beyond transform their digital presence.
              Check out some of our recent work.
            </p>
          </div>

          <div className="portfolio-filters">
            <button 
              className={`portfolio-filter ${activePortfolioFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActivePortfolioFilter('all')}
            >
              All
            </button>
            <button 
              className={`portfolio-filter ${activePortfolioFilter === 'web' ? 'active' : ''}`}
              onClick={() => setActivePortfolioFilter('web')}
            >
              Web
            </button>
            <button 
              className={`portfolio-filter ${activePortfolioFilter === 'mobile' ? 'active' : ''}`}
              onClick={() => setActivePortfolioFilter('mobile')}
            >
              Mobile
            </button>
            <button 
              className={`portfolio-filter ${activePortfolioFilter === 'design' ? 'active' : ''}`}
              onClick={() => setActivePortfolioFilter('design')}
            >
              Design
            </button>
            <button 
              className={`portfolio-filter ${activePortfolioFilter === 'software' ? 'active' : ''}`}
              onClick={() => setActivePortfolioFilter('software')}
            >
              Software
            </button>
          </div>

          <div className="portfolio-grid">
            {filteredPortfolio.map((item, index) => (
              <div 
                key={item.id} 
                className="portfolio-item"
                style={{ animationDelay: `${0.1 * index}s` }}
              >
                <img src={item.image} alt={item.title} className="portfolio-image" />
                <div className="portfolio-overlay">
                  <p className="portfolio-category">{item.category}</p>
                  <h3 className="portfolio-title">{item.title}</h3>
                  <p style={{ color: 'var(--gray-light)', marginBottom: '1rem' }}>Client: {item.client}</p>
                  <Link to={`/portfolio/${item.id}`} className="portfolio-link">
                    View Details <i className="fas fa-arrow-right ml-1"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <Link to="/portfolio" className="btn btn-icon">
              <span>View All Projects</span>
              <i className="fas fa-arrow-right ml-1"></i>
            </Link>
          </div>
        </div>
      </section> */}

      {/* Process Section */}
      <section id="process" className={`section ${isVisible.process ? 'animate-fadeUp' : ''}`}>
        <div className="container">
          <div className="text-center">
            <p className="section-subtitle">How We Work</p>
            <h2 className="section-title">Our Process</h2>
            <div className="divider"></div>
            <p className="section-description">
              We follow a structured approach to deliver projects efficiently and effectively,
              ensuring transparent communication and high-quality results.
            </p>
          </div>

          <div className="process-steps">
            <div className="process-step" style={{ animationDelay: '0.1s' }}>
              <div className="process-number">1</div>
              <div className="process-content">
                <h3 className="process-title">Discovery & Planning</h3>
                <p>
                  We start by understanding your business goals, target audience, and project requirements.
                  This helps us create a detailed roadmap for your project, ensuring alignment with your vision.
                </p>
              </div>
            </div>

            <div className="process-step" style={{ animationDelay: '0.2s' }}>
              <div className="process-number">2</div>
              <div className="process-content">
                <h3 className="process-title">Design & Prototyping</h3>
                <p>
                  Our designers create wireframes and interactive prototypes to visualize the user interface
                  and experience. We refine these based on your feedback until we achieve the perfect design.
                </p>
              </div>
            </div>

            <div className="process-step" style={{ animationDelay: '0.3s' }}>
              <div className="process-number">3</div>
              <div className="process-content">
                <h3 className="process-title">Development</h3>
                <p>
                  Our development team brings the designs to life, writing clean, efficient code
                  and implementing all required functionality with attention to performance and security.
                </p>
              </div>
            </div>

            <div className="process-step" style={{ animationDelay: '0.4s' }}>
              <div className="process-number">4</div>
              <div className="process-content">
                <h3 className="process-title">Testing & Quality Assurance</h3>
                <p>
                  We rigorously test all features to ensure everything works perfectly across all devices
                  and browsers, fixing any issues that arise before the final delivery.
                </p>
              </div>
            </div>

            <div className="process-step" style={{ animationDelay: '0.5s' }}>
              <div className="process-number">5</div>
              <div className="process-content">
                <h3 className="process-title">Deployment & Launch</h3>
                <p>
                  Once everything is approved, we deploy your project to the live environment,
                  ensuring a smooth launch and proper configuration of all systems.
                </p>
              </div>
            </div>

            <div className="process-step" style={{ animationDelay: '0.6s' }}>
              <div className="process-number">6</div>
              <div className="process-content">
                <h3 className="process-title">Ongoing Support</h3>
                <p>
                  Our relationship doesn't end at launch. We provide ongoing support and maintenance
                  to ensure your digital product continues to perform at its best and evolves with your needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section id="testimonials" className={`section ${isVisible.testimonials ? 'animate-fadeUp' : ''}`} style={{ backgroundColor: 'rgba(17, 24, 39, 0.4)' }}>
        <div className="container">
          <div className="text-center">
            <p className="section-subtitle">Client Feedback</p>
            <h2 className="section-title">What Our Clients Say</h2>
            <div className="divider"></div>
          </div>

          <div className="grid grid-3">
            {testimonials.map((testimonial, index) => (
              <div 
                key={testimonial.id} 
                className="testimonial-card"
                style={{ animationDelay: `${0.1 * index}s` }}
              >
                <p className="testimonial-content">
                  {testimonial.content}
                </p>
                <div className="testimonial-author">
                  <div className="testimonial-avatar">
                    <img src={testimonial.avatar} alt={testimonial.author} />
                  </div>
                  <div className="testimonial-info">
                    <h4>{testimonial.author}</h4>
                    <p>{testimonial.position}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* Technologies Section */}
      <section id="tech" className={`section ${isVisible.tech ? 'animate-fadeUp' : ''}`}>
        <div className="container">
          <div className="text-center">
            <p className="section-subtitle">Our Tech Stack</p>
            <h2 className="section-title">Technologies We Use</h2>
            <div className="divider"></div>
            <p className="section-description">
              We work with cutting-edge technologies to build scalable, performant, and secure digital products.
            </p>
          </div>

          <div className="grid grid-4">
            <div className="tech-card" style={{ animationDelay: '0.1s' }}>
              <div className="tech-icon">
                <i className="fab fa-react"></i>
              </div>
              <h3 className="tech-name">React</h3>
              <p>
                For building interactive user interfaces and single-page applications with reusable components.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.2s' }}>
              <div className="tech-icon">
                <i className="fab fa-node-js"></i>
              </div>
              <h3 className="tech-name">Node.js</h3>
              <p>
                Server-side JavaScript for building scalable network applications.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.3s' }}>
              <div className="tech-icon">
                <i className="fab fa-angular"></i>
              </div>
              <h3 className="tech-name">Angular</h3>
              <p>
                A platform and framework for building single-page client applications.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.4s' }}>
              <div className="tech-icon">
                <i className="fab fa-swift"></i>
              </div>
              <h3 className="tech-name">Swift</h3>
              <p>
                For building native iOS applications with powerful features and smooth performance.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.5s' }}>
              <div className="tech-icon">
                <i className="fab fa-android"></i>
              </div>
              <h3 className="tech-name">Android</h3>
              <p>
                Native Android development for creating robust mobile applications.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.6s' }}>
              <div className="tech-icon">
                <i className="fab fa-python"></i>
              </div>
              <h3 className="tech-name">Python</h3>
              <p>
                Versatile language for web development, data analysis, and machine learning.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.7s' }}>
              <div className="tech-icon">
                <i className="fab fa-aws"></i>
              </div>
              <h3 className="tech-name">AWS</h3>
              <p>
                Cloud computing services for scalable and reliable infrastructure.
              </p>
            </div>

            <div className="tech-card" style={{ animationDelay: '0.8s' }}>
              <div className="tech-icon">
                <i className="fab fa-figma"></i>
              </div>
              <h3 className="tech-name">Figma</h3>
              <p>
                Collaborative interface design tool for creating beautiful user experiences.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      {/* <section className="section-sm" style={{ backgroundColor: 'rgba(17, 24, 39, 0.4)' }}>
        <div className="container">
          <div className="grid grid-4">
            <div className="text-center animate-fadeUp" style={{ animationDelay: '0.1s' }}>
              <h2 className="text-gradient" style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                50+
              </h2>
              <p style={{ textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '500' }}>Projects Completed</p>
            </div>
            
            <div className="text-center animate-fadeUp" style={{ animationDelay: '0.2s' }}>
              <h2 className="text-gradient" style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                30+
              </h2>
              <p style={{ textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '500' }}>Happy Clients</p>
            </div>
            
            <div className="text-center animate-fadeUp" style={{ animationDelay: '0.3s' }}>
              <h2 className="text-gradient" style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                5+
              </h2>
              <p style={{ textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '500' }}>Years Experience</p>
            </div>
            
            <div className="text-center animate-fadeUp" style={{ animationDelay: '0.4s' }}>
              <h2 className="text-gradient" style={{ fontSize: '3.5rem', fontWeight: '800', marginBottom: '0.5rem' }}>
                12+
              </h2>
              <p style={{ textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '500' }}>Industry Awards</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container cta-content">
          <h2 className="cta-title animate-fadeUp">Ready to Transform Your Digital Presence?</h2>
          <p className="cta-description animate-fadeUp delay-1">
            Let's discuss how we can help you achieve your business goals with our custom digital solutions.
          </p>
          <Link to="/contact" className="btn btn-secondary btn-icon animate-fadeUp delay-2">
            <span>Start Your Project</span>
            <i className="fas fa-rocket ml-1"></i>
          </Link>
        </div>
      </section>
    </>
  );
};

export default Home;